<script lang="ts" setup>
import {
  TextField,
  pipeu,
  validateNoSpaces,
  validateNoSpecialCharacters,
  validateMinLength,
  validateMaxLength
} from '@idem/ui';

const props = defineProps<{ username?: string }>();
const emit = defineEmits(['error', 'update']);

const validateInput = pipeu(
  validateNoSpaces,
  validateNoSpecialCharacters,
  validateMinLength(3),
  validateMaxLength(36),
);
</script>

<template>
  <TextField
    :validator="validateInput"
    :value="props.username"
    field="usuario"
    label="Usuario"
    @error="(e: string) => emit('error', e)"
    @update="(e: any) => emit('update', e)"
  />
</template>

<style scoped></style>
